import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media (max-width: 917px) {
        gap: 4px;
    }
`;

export const Label = styled.div`
    color: rgba(255, 255, 255, 0.5);
    font-size: 12px;
    font-weight: 500;
    line-height: 120%;
    letter-spacing: -0.36px;
`;

export const ValueWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const Value = styled.div`
    color: #fff;
    font-size: 24px;
    font-weight: 600;
    line-height: 100%;
    letter-spacing: -1.5px;
    font-variant-numeric: tabular-nums;

    @media (max-width: 917px) {
        font-size: 16px;
        font-weight: 600;
    }
`;

export const DiffWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1px;
    padding-top: 1px;
`;

export const SubLabel = styled.div`
    color: #666;
    font-size: 9px;
    font-weight: 600;
    line-height: 100%;

    @media (max-width: 917px) {
        display: none;
    }
`;
